import { Model } from './_model';
import defaultIcon from '../assets/www.svg';
import { ATP_ARCHIVE_NOT_STARTED } from '../helpr/constants';

export class Security extends Model {
  get defaults() {
    return {
      securityId: "",
      issuer: "",
      securityName: "",
      price: "",
      offerDate: "",
      offerCloseDate: "",
      interestPaymentDate: "",
      interestRate: "",
      maturityDate: "",
      entityIdList: [],
      denomination: {
        description: "",
        value: {
          primary: {
            minimum: 0.0,
            increments: 0.0,
          }
        }
      },
      currency: "",
      allocation: "",
      offerSize: "",
      securityStatus: '',
      archiveStatus: ATP_ARCHIVE_NOT_STARTED,
      submittedDate: '',
      authorizedDate: '',
      createdDate: "",
      lastUpdatedDate: "",
      issueSiteUrl: null,
      iconUrl: null
    }
  }

  get iconUrlSrc() {
    if (this.iconUrl == null) {
      return defaultIcon;
    }
    return this.iconUrl;
  }
}


